(function () {
  var COOLDOWN_MS = 1500;
  var SAFETY_MS = 8000;

  var wrap = document.getElementById('product-add');
  if (!wrap || wrap.dataset.atcGuard) return;
  wrap.dataset.atcGuard = '1';

  var inFlight = false;
  var cooldown = false;
  var safetyTimer = null;

  function btn() { return wrap.querySelector('.add-to-cart, [type="submit"]'); }

  function lock() {
    inFlight = true;
    wrap.classList.add('atc-locked');
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(function () { settle(); }, SAFETY_MS);
  }

  function settle() {
    clearTimeout(safetyTimer);
    inFlight = false;
    cooldown = true;
    setTimeout(function () {
      cooldown = false;
      wrap.classList.remove('atc-locked');
    }, COOLDOWN_MS);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var b = btn();
    var isAtcForm = form && typeof form.contains === 'function' &&
      ((b && form.contains(b)) ||
       (form.getAttribute && /\/cart\/add/.test(form.getAttribute('action') || '')));
    if (!isAtcForm) return;
    if (inFlight || cooldown) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    lock();
  }, true);

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = /\/cart\/add(\.js)?/.test(url) && /post/i.test(method);
      var p = nativeFetch.apply(this, arguments);
      if (isAdd) {
        p.then(function () { settle(); })
         .catch(function () { settle(); });
      }
      return p;
    };
  }
})();
